export const FOLDER_NAME_REGEX = /^[a-z0-9A-Z\-_\s]+$/;
